import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { Button, DatePicker, Output, Select } from "@ds/ds-snam/react";
import SimpleTable, { SimpleTableType } from "components/SimpleTable";
import TableRighArrow from "components/TableRightArrow";

import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { dsSelectHandler } from "shared/utils/dsComponentUtils";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { v4 as uuid } from "uuid";
import styles from "views/b2bView/styles/bookingDataStyles.module.css";
import userIcon from "shared/assets/icons/Avatar.svg";
import { AppUserGrant, IAppUserProfile, ResponseCode, ResponseStatus, RoutePath, SnamPlantKey, SupplyingResultIdStatus } from "shared/constants";
import { postPreBillingReport } from "net/prebilling";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import { parseService } from "views/contractView/shared/listUtils";
import useAppUser from "hooks/useAppUser";
import { appStore } from "state/appStore";

const PreBillingData:React.FC<{}> = ():JSX.Element=>{
    const { codeIup } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(["preBilling", "app","b2b"]);
    const dispatch = useDispatch();
    const appUserProfile: IAppUserProfile | undefined = useAppUser()?.userProfile;
    const plantIdValue: string|undefined = appStore.getState().plant.plantId;
    
    const saveData = () => {
        postPreBillingReport('restore',location.state.report)
        .then((response) => { 
            let popUpAction: INotificationAction;
            const popUpTitle:string = response.data.status===ResponseStatus.ERROR ? 'Error':(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT? 'OK-422': t('preBilling.preBillingData.toast.0') );
            const popUpDescription:string = response.data.status===ResponseStatus.ERROR||response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?response.data.message:t('preBilling.preBillingData.toast.2');
            const popUpStatus:NotificationsStatusType = response.data.status===ResponseStatus.ERROR?"error":(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");
            popUpAction = {
                show: true,
                title: popUpTitle,
                description: popUpDescription,
                status: popUpStatus,
                onClose: (event: Event) => {
                    dispatch(hideNotification());
                }
            };
            dispatch(showNotification(popUpAction));
            navigate(RoutePath.PRE_BILLING_INFO);
        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {
            dispatch(requestPristine());
        })
    }

    return (
        <>
            <Row>
                <Col>
                    <p className="pageTitle">
                        {t('preBilling.preBillingData.titles.0')} {/*Dettagli servizio fruito*/}
                    </p>
                </Col>
            </Row>
            {/*<Row>
                <Col>
                    <div className="pageSubTitle">
                         <div>
                         {t('preBilling.preBillingData.titles.1')}
                        </div>
                    </div>
                </Col>
            </Row>*/}
            <Row>
                <Col>
                    <div className="driverDataContainer">

                        <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "24px" }}>
                            <ds-avatar avatar-type="icon" avatar-size="large"></ds-avatar>
                            {/*<div style={{ backgroundColor: "var(--interaction-active)", width: "64px", height: "64px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <ds-icon
                                    icon="icon-avatar"
                                    role="link"
                                    icon-size="large"
                                    icon-filled={false}
                                ></ds-icon>
                            </div>*/}
                            <div className="avatarNotes--driver">
                                <div>
                                    <span>
                                        {t('preBilling.preBillingData.labels.0')}
                                    </span>
                                    <span> {location.state.report.businessName/*location.state.report.clientId*/} </span>
                                </div>
                                <div>
                                    <span>
                                        {t('preBilling.preBillingData.labels.1')}
                                    </span>
                                    <span> {location.state.report.contractCode/*location.state.report.contractId*/} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Container fluid className="driverDataContainer" style={{marginTop:'-20px'}}>
                <Row style={{marginBottom:'16px'}}>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.2')}
                            outputText={location.state.report.reservationCode}
                            
                        ></Output>
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.2')}
                        </p>
                        <div className="driverDataBoxText">
                            <p>{location.state.report.codeIup}</p>
                        </div>*/}
                    </Col>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.3')}
                            outputText={parseDateForDS(location.state.report.date,IParseDateFormatType.DATE_FORMAT2)}
                            
                        ></Output>
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.3')}
                        </p>
                        <div className="driverDataBoxText">
                            <p>{location.state.report.date}</p>
                        </div>*/}
                    </Col>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.4')}
                            outputText={location.state.report.time}
                            
                        ></Output>
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.4')}
                        </p>
                        <div className="driverDataBoxText">
                            <p>{location.state.report.time}</p>
                        </div>*/}
                    </Col>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.5')}
                            outputText={parseService(location.state.report.service)} //{location.state.report.service}
                            
                        ></Output>
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.5')}
                        </p>
                        <div className="driverDataBoxText">
                            <p>{location.state.report.service}</p>
                        </div>*/}
                    </Col>
                </Row>
                <Row style={{marginBottom:'16px'}}>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.6')}
                            outputText={location.state.report.cost}
                            
                        ></Output>
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.6')}
                        </p>
                        <div className="driverDataBoxText">
                            <p>{location.state.report.cost}</p>
                        </div>*/}
                    </Col>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.7')}
                            outputText={location.state.report.shipperName}
                            
                        ></Output>
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.7')}
                        </p>
                        <div className="driverDataBoxText">
                            <p>{location.state.report.shipperName}</p>
                        </div>*/}
                    </Col>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.8')}
                        ></Output>
                        {location.state.report.supplyingResultId===SupplyingResultIdStatus.POSITIVE &&
                            <Output
                                outputText={t('preBilling.preBillingData.labels.14')}
                                
                            ></Output>
                        }
                        {location.state.report.supplyingResultId===SupplyingResultIdStatus.FTT &&
                            <Output
                                outputText={"Failure To Take"}
                                
                            ></Output>
                        }
                        {location.state.report.supplyingResultId===SupplyingResultIdStatus.FTD &&
                            <Output
                                outputText={"Failure To Deliver"}
                                
                            ></Output>
                        }
                        {location.state.report.supplyingResultId===SupplyingResultIdStatus.CANCELED &&
                            <Output
                                outputText={t('preBilling.preBillingData.labels.13')}
                                
                            ></Output>
                        }
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.8')}
                        </p>
                        <div className="driverDataBoxText">
                            {location.state.report.supplyingResultId===SupplyingResultIdStatus.POSITIVE && <p>{t('preBilling.preBillingData.labels.14')}</p>}
                            {location.state.report.supplyingResultId===SupplyingResultIdStatus.FTT && <p>Failure To Take</p>}
                            {location.state.report.supplyingResultId===SupplyingResultIdStatus.FTD && <p>Failure To Deliver</p>}
                            {location.state.report.supplyingResultId===SupplyingResultIdStatus.CANCELED && <p>{t('preBilling.preBillingData.labels.13')}</p>}
                        </div>*/}
                    </Col>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.15')}
                            outputText={t('booking.bookingData.bookingStatus.' + location.state.report.reservationStatusId,{ns:['b2b']})}
                            
                        ></Output>
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.9')}
                        </p>
                        <div className="driverDataBoxText">
                            <p>{location.state.report.energy}</p>
                        </div>*/}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.9')}
                            outputText={location.state.report.energy}
                            
                        ></Output>
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.9')}
                        </p>
                        <div className="driverDataBoxText">
                            <p>{location.state.report.energy}</p>
                        </div>*/}
                    </Col>
                    <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.10')}
                            outputText={location.state.report.mass}
                            
                        ></Output>
                        {/*<p className="driverDataBoxTitle">
                        {t('preBilling.preBillingData.labels.10')}
                        </p>
                        <div className="driverDataBoxText">
                            <p>{location.state.report.mass}</p>
                        </div>*/}
                    </Col>
                    {plantIdValue===SnamPlantKey.PIGNATARO && 
                        <Col xs={12} md={3}>
                        <Output
                            outputTitle={t('preBilling.preBillingData.labels.16')}
                            outputText={
                                (location.state.report.dailyGasPrice!==undefined && location.state.report.dailyGasPrice!==null) ?
                                    location.state.report.dailyGasPrice
                                :
                                    "-"
                            }
                        ></Output>
                    </Col>
                    }
                </Row>
                {appUserProfile?.prebillingGrants.includes(AppUserGrant.EDIT) && <> {/**  !== reader */}
                    <Button 
                        style={{  float:'right',marginLeft:'15px',marginTop:'50px'}}
                        buttonUIVariant="primary"
                        buttonSize="medium"
                        buttonLabel={t('preBilling.preBillingData.labels.12')}//"Modifica informazioni"
                        onClickEvent={() => {
                            navigate(RoutePath.PRE_BILLING_EDIT+ `/${location.state.report.codeIup}`,{state:{report:location.state.report}});          
                        }}
                    ></Button>  
                    <Button 
                        style={{float:'right',marginTop:'50px'}}
                        buttonUIVariant="secondary"
                        buttonSize="medium"
                        buttonLabel={t('preBilling.preBillingData.labels.11')}//"Ripristina"
                        onClickEvent={() => {
                            saveData();            
                        }}
                    ></Button>
                </>
                }
            </Container>
            
        </>
    );
}
export default PreBillingData;